import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { User } from '@core/objects/user';
import { Organization } from '@core/objects/organization';
import { AccountSession } from '@core/objects/account-session';

import { AppRequests } from './app.requests';
import { Session } from '@app/store/models/session.model';

import * as fromStore from './app.state';
import * as fromActions from './app.actions';


@Injectable()
export class AppEffects {
    constructor(private actions$: Actions, private store$: Store<fromStore.App>, private appReq: AppRequests) {}

    
    public loadSessionEffect$: Observable<fromActions.AppActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadSessionRequest>(fromActions.AppActionTypes.LoadSessionRequest),
        mergeMap(() =>
            this.appReq.getSession$().pipe(
                map((session: Session) => {
                    return new fromActions.LoadSessionSuccess(session);
                }),
                catchError((err: any) => {
                    console.log(err);
                    //window.location.href = '/login?href='+encodeURIComponent(window.location.href);
                    return throwError(() =>err);
                })
            )
        )
    ));

    // Runs in parallel with loadSessionEffect$, off the same LoadSessionRequest trigger: separate
    // accounts-api host, so it's independent of the (legacy) session call above succeeding or failing.
    public loadAccountSessionEffect$: Observable<fromActions.AppActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadSessionRequest>(fromActions.AppActionTypes.LoadSessionRequest),
        mergeMap(() => {
            return this.appReq.getAccountSession$().pipe(
                map((accountSession: AccountSession) => {
                    // TEMP-TEST remove after // uncomment for testing the access-denied flow:
                    // accountSession.current.apps = accountSession.current.apps.filter((a: string) => a !== 'ams');
                    return new fromActions.LoadAccountSessionSuccess(accountSession);
                }),
                catchError((err: any) => {
                    return of(new fromActions.LoadAccountSessionError());
                })
            );
        })
    ));


    
    public changeOrganizationEffect$: Observable<fromActions.AppActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.ChangeOrganization>(fromActions.AppActionTypes.ChangeOrganization),
        mergeMap((action) => {
            return this.appReq.changeOrganization$(action.organization).pipe(
                map(() => new fromActions.LoadSessionRequest()),
                catchError((err: any) => {
                    console.log(err);
                    //window.location.href = '/login?href='+window.location.href;
                    return throwError(() =>err);
                })
            )}
        )
    ));

    
    public updateUserEffect$: Observable<fromActions.AppActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateUser>(fromActions.AppActionTypes.UpdateUser),
        withLatestFrom(this.store$.select(fromStore.appSessionSelector)),
        mergeMap(([action, session]) =>
            this.appReq.updateUser$(session.current.user, action.name).pipe(
                map((user: User) => new fromActions.UpdateUserSuccess(user)),
                catchError((err: any) => {
                    console.log(err);
                    return of(new fromActions.UpdateUserError());
                    // return throwError(err);
                })
            )
        )
    ));
}
